import { BaseHTTPClient } from '../api/http-client.service';
import { APIType } from '../api/configuration';
import { ApiConfig } from '../api/api-service/api-config.model';

export class ClientsService extends BaseHTTPClient {
    public static async getClients(payload: any) {
        return this.sendToGateway({
            url: `${process.env.REACT_APP_API_URL}/clientProfile/`,
            method: APIType.GET,
            data: payload,
        });
    }
    public static async addClient(payload: any) {
        return this.sendToGateway({
           url: `${process.env.REACT_APP_API_URL}/clientProfile/upload`,
           method: APIType.POST,
           data: payload
        });
    }
    public static async deleteClient(payload: any) {
        return this.sendToGateway({
           url: `${process.env.REACT_APP_API_URL}/clientProfile/`,
           method: APIType.DELETE,
           data: payload
        });
    }
}
